import { Avatar, Stack, Typography } from '@mui/material';
import { LinkArrowLeft2 } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { MagnifyGlassPaperCheckmarks } from 'Images';

export const IntroInformation = () => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Status
  ).introInformation;
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction={isDesktop ? 'row' : 'column-reverse'}
      alignItems='center'
      margin={isDesktop ? '50px 0' : '32px 0'}
      rowGap='16px'
    >
      <Stack width='fit-content' justifyContent='space-around'>
        <Typography variant='h5' mb={isDesktop ? '12px' : '8px'} component='h4'>
          {dictionary.title}
        </Typography>
        <Typography
          variant='body3'
          maxWidth='514px'
          mb={isDesktop ? '16px' : '16px'}
        >
          {dictionary.information}
        </Typography>
        <Stack direction='row' columnGap='8px' flexWrap='wrap'>
          <Typography variant='body3'>{dictionary.summarize}</Typography>
          <LinkArrowLeft2
            text={dictionary.digitalFolder}
            href='/documents'
            newWindow={false}
          />
        </Stack>
      </Stack>
      <Avatar
        alt=''
        src={MagnifyGlassPaperCheckmarks}
        sx={{
          width: isDesktop ? '300px' : '200px',
          height: isDesktop ? '176px' : '117px',
        }}
      />
    </Stack>
  );
};
